var map = {
	"./short-01.png": 2113,
	"./short-02.png": 2114,
	"./short-03.png": 2115,
	"./short-04.png": 2116,
	"./short-05.png": 2117,
	"./short-06.png": 2118,
	"./short-07.png": 2119,
	"./short-08.png": 2120,
	"./short-09.png": 2121,
	"./short-10.png": 2122,
	"./short-11.png": 2123
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2112;


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/short ^\.\/.*$
// module id = 2112
// module chunks = 0